import { createSelector } from 'reselect'

export const getPromoVehicleParts = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.list && Array.isArray(state.vehicleParts.list.promoProducts) ? state.vehicleParts.list.promoProducts : [],
  promoProducts => promoProducts
)
